export function buildProductFormData(product = {}) {
  return {
    product: {
      name: product.name || "",
      description: product.description || "",
      index: product.index ?? 0
    }
  };
}
